import React, { useEffect } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Switch, Route } from "react-router-dom";

import { setLanguage } from "../actions/languageActions";

import Ceme from "./ceme/Ceme";
import NotFound from "./static/NotFound";

const mapStateToProps = (state: {
  i18n: {
    locale: string;
  };
}) => ({
  lang: state.i18n.locale,
});
const mapDispatch = { setLanguage };
const connector = connect(mapStateToProps, mapDispatch);

type ReduxProps = ConnectedProps<typeof connector>;
type Props = ReduxProps & {
  lang: string;
  locale: string;
  pathname: string;
};

let Router: React.FC<Props> = (props: Props) => {
  useEffect(() => {
    props.setLanguage(props.locale);
  }, [props]);

  return (
    <Switch>
      <Route path={`/${props.lang}/site-ceme`} component={() => <Ceme />} />
      <Route component={NotFound} />
    </Switch>
  );
};

export default connector(Router);
